/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetOrgStatusesForSidebarQueryVariables = Types.Exact<{
  orgId: Types.Scalars["OrgId"]["input"];
}>;

export type GetOrgStatusesForSidebarQuery = {
  readonly __typename: "Query";
  readonly orgById: {
    readonly __typename: "Org";
    readonly id: c.OrgId;
    readonly statuses: ReadonlyArray<{
      readonly __typename: "Status";
      readonly id: c.StatusId;
      readonly inLibrary: boolean;
      readonly endorsed: boolean;
    }>;
  };
};

export const GetOrgStatusesForSidebarDocument = /*#__PURE__*/ gql`
  query GetOrgStatusesForSidebar($orgId: OrgId!) {
    orgById(orgId: $orgId) {
      id
      statuses {
        id
        inLibrary
        endorsed
      }
    }
  }
`;

/**
 * __useGetOrgStatusesForSidebarQuery__
 *
 * To run a query within a React component, call `useGetOrgStatusesForSidebarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgStatusesForSidebarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgStatusesForSidebarQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetOrgStatusesForSidebarQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetOrgStatusesForSidebarQuery,
    GetOrgStatusesForSidebarQueryVariables
  > &
    (
      | { variables: GetOrgStatusesForSidebarQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetOrgStatusesForSidebarQuery,
    GetOrgStatusesForSidebarQueryVariables
  >(GetOrgStatusesForSidebarDocument, options);
}
export function useGetOrgStatusesForSidebarLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOrgStatusesForSidebarQuery,
    GetOrgStatusesForSidebarQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetOrgStatusesForSidebarQuery,
    GetOrgStatusesForSidebarQueryVariables
  >(GetOrgStatusesForSidebarDocument, options);
}
export function useGetOrgStatusesForSidebarSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetOrgStatusesForSidebarQuery,
    GetOrgStatusesForSidebarQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetOrgStatusesForSidebarQuery,
    GetOrgStatusesForSidebarQueryVariables
  >(GetOrgStatusesForSidebarDocument, options);
}
export type GetOrgStatusesForSidebarQueryHookResult = ReturnType<
  typeof useGetOrgStatusesForSidebarQuery
>;
export type GetOrgStatusesForSidebarLazyQueryHookResult = ReturnType<
  typeof useGetOrgStatusesForSidebarLazyQuery
>;
export type GetOrgStatusesForSidebarSuspenseQueryHookResult = ReturnType<
  typeof useGetOrgStatusesForSidebarSuspenseQuery
>;
export type GetOrgStatusesForSidebarQueryResult = Apollo.QueryResult<
  GetOrgStatusesForSidebarQuery,
  GetOrgStatusesForSidebarQueryVariables
>;
